export class IMasonryGalleryImage {
    public imageUrl: string;
    public alt?: string;
}
